import React, { Component } from 'react';
import { Container, Card, Table, Row, Col, Button, Offcanvas, Modal, Form, Spinner, Tabs, Tab, Badge, Alert } from 'react-bootstrap';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faArrowAltCircleLeft, faFilePdf, faInfoCircle, faPlus, faTimesCircle } from '@fortawesome/free-solid-svg-icons';
import { faCircle, faCheckCircle, faCircleDot, faComments } from '@fortawesome/free-regular-svg-icons';
import { brand_colors } from '../../../helpers/brand_colors_helper';
import { t } from '../../../helpers/translation_helper';
import { connect } from 'react-redux';
import { setUpdateZatcaModal } from '../../../redux/slices/updateZatcaModalSlice';
import { setAuthentication } from '../../../redux/slices/authSlice';
import axios from 'axios';
import { toast } from 'react-toastify';
import Select from 'react-select';
import Flatpickr from 'react-flatpickr';
import moment from 'moment';
import { GET, POST } from '../../../api';
import { handleFormErrors } from '../../../helpers/form_helpers';

// API URL
const apiURL = process.env.REACT_APP_API_URL;
const localTestData = {
    'cz_email': 'support@fatoorazatca.com',
    'cz_common_name': 'TST-886431145-399999999900003',
    'cz_org_unit_name': 'Riyadh Branch',
    'cz_org_name': 'Maximum Speed Tech Supply LTD',
    'cz_tax_num': '399999999900003',
    'cz_reg_address': 'RRRD2929',
    'cz_business_category': 'Supply activities',
    'cz_egs_serial_num': '',//1-TST|2-TST|3-ed22f1d8-e6a2-1118-9b58-d9a8f11e445f
    'cz_reg_num': '2252039485',
    'cz_invoice_type': { label: 'BOTH', value: 'BOTH' },
    'cz_country': { label: 'Saudi Arabia', value: 'SA' },
    'cz_otp': '123456',
    'cz_street': 'street',
    'cz_building': '0000',//4 digits
    'cz_district': 'district',
    'cz_postal_code': '00000',//5 digits
    'cz_city': 'city',
    'cz_secondary_num': '1234',//4 digits
    'cz_zatca_settings': null,
    'last_invoice_hash': null,
}


const localArtalData = {
    'cz_email': 'support@fatoorazatca.com',
    'cz_common_name': 'Educore',
    'cz_org_unit_name': 'Main Branch',
    'cz_org_name': 'Artal United For Education Company',
    'cz_tax_num': '310184166500003',
    'cz_reg_address': 'RYSA8704',
    'cz_business_category': 'Education',
    'cz_egs_serial_num': '',//1-TST|2-TST|3-ed22f1d8-e6a2-1118-9b58-d9a8f11e445f
    'cz_reg_num': '1010652147',
    'cz_invoice_type': { label: 'BOTH', value: 'BOTH' },
    'cz_country': { label: 'Saudi Arabia', value: 'SA' },
    'cz_otp': '',
    'cz_street': 'Abu Al Wafa Al Buzjani',
    'cz_building': '8704',//4 digits
    'cz_district': 'Assafarat Dist.',
    'cz_postal_code': '12523',//5 digits
    'cz_city': 'Riyadh',
    'cz_secondary_num': '3153',//4 digits
    'cz_zatca_settings': null,
    'last_invoice_hash': null,
}

class UpdateZatcaModal extends Component {

    logo = React.createRef();
    center_stamp = React.createRef();
    ministry_logo = React.createRef();

    formSections = [
        {
            uid: '1',
            active: true,
            completed: false,
            name: 'General',
            desc: null,
            data: [
                {
                    uid: '1.1',
                    active: false,
                    completed: false,
                    name: 'OTP',
                    key: 'cz_otp',
                    desc: 'Please login to Fatoora Portal and generate the OTP (It is only required once)',
                    image: require('../../../assets/images/lesson/lesson-focus.png'),
                },
                {
                    uid: '1.2',
                    active: false,
                    completed: false,
                    name: 'Email',
                    key: 'cz_email',
                    desc: null,
                    image: require('../../../assets/images/lesson/lesson-focus.png'),
                },
                {
                    uid: '1.3',
                    active: false,
                    completed: false,
                    name: 'Common Name',
                    key: 'cz_common_name',
                    desc: 'Provided by the\r\nTaxpayer for each\r\nSolution unit: Unique\r\nName or Asset\r\nTracking Number of\r\nthe Solution Unit',
                    image: require('../../../assets/images/lesson/lesson-focus.png'),
                },
                {
                    uid: '1.4',
                    active: false,
                    completed: false,
                    name: 'Organizational Unit Name',
                    key: 'cz_org_unit_name',
                    desc: 'The branch name\r\nfor Taxpayers. In\r\ncase of VAT Groups\r\nthis field should\r\ncontain the 10-digit\r\nTIN number of the\r\nindividual group\r\nmember whose EGS\r\nUnit is being onboarded',
                    image: require('../../../assets/images/lesson/lesson-focus.png'),
                },
                {
                    uid: '1.5',
                    active: false,
                    completed: false,
                    name: 'Organization Name',
                    key: 'cz_org_name',
                    desc: 'Organization/Taxpayer Name',
                    image: require('../../../assets/images/lesson/lesson-focus.png'),
                },
                {
                    uid: '1.6',
                    active: false,
                    completed: false,
                    name: 'Tax Number',
                    key: 'cz_tax_num',
                    desc: 'VAT Registration\r\nNumber of the\r\nTaxpayer (Taxpayer\r\n/ Taxpayer device to\r\nprovide this to allow\r\nto check if the OTP is\r\ncorrectly associated\r\nwith this TIN)',
                    image: require('../../../assets/images/lesson/lesson-focus.png'),
                },
                {
                    uid: '1.7',
                    active: false,
                    completed: false,
                    name: 'Registered Address',
                    key: 'cz_reg_address',
                    desc: 'The address of the\r\nBranch or location\r\nwhere the device\r\nor solution unit is\r\nprimarily situated\r\n(could be website\r\naddress for e-commerce). Preferably\r\nin the Short Address\r\nformat of the Saudi\r\nNational Address\r\nhttps://splonline.\r\ncom.sa/en/national-address-1/',
                    image: require('../../../assets/images/lesson/lesson-focus.png'),
                },
                {
                    uid: '1.8',
                    active: false,
                    completed: false,
                    name: 'Business Category',
                    key: 'cz_business_category',
                    desc: 'Industry or sector for\r\nwhich the device or\r\nsolution will generate invoices',
                    image: require('../../../assets/images/lesson/lesson-focus.png'),
                },
                {
                    uid: '1.9',
                    active: false,
                    completed: false,
                    name: 'EGS Serial Number (Auto Generated)',
                    key: 'cz_egs_serial_num',
                    desc: 'Automatically filled\r\nand not by the\r\nTaxpayer: Unique\r\nidentification code\r\nfor the EGS.',
                    image: require('../../../assets/images/lesson/lesson-focus.png'),
                },
                {
                    uid: '1.10',
                    active: false,
                    completed: false,
                    name: 'Registration Number',
                    key: 'cz_reg_num',
                    desc: null,
                    image: require('../../../assets/images/lesson/lesson-focus.png'),
                },
                {
                    uid: '1.11',
                    active: false,
                    completed: false,
                    name: 'Invoice Type',
                    key: 'cz_invoice_type',
                    desc: null,
                    image: require('../../../assets/images/lesson/lesson-focus.png'),
                },
                {
                    uid: '1.12',
                    active: false,
                    completed: false,
                    name: 'Country',
                    key: 'cz_country',
                    desc: null,
                    image: require('../../../assets/images/lesson/lesson-focus.png'),
                },

                {
                    uid: '1.13',
                    active: false,
                    completed: false,
                    name: 'Street',
                    key: 'cz_street',
                    desc: null,
                    image: require('../../../assets/images/lesson/lesson-focus.png'),
                },
                {
                    uid: '1.14',
                    active: false,
                    completed: false,
                    name: 'Building',
                    key: 'cz_building',
                    desc: null,
                    image: require('../../../assets/images/lesson/lesson-focus.png'),
                },
                {
                    uid: '1.15',
                    active: false,
                    completed: false,
                    name: 'District',
                    key: 'cz_district',
                    desc: null,
                    image: require('../../../assets/images/lesson/lesson-focus.png'),
                },
                {
                    uid: '1.16',
                    active: false,
                    completed: false,
                    name: 'Postal Code',
                    key: 'cz_postal_code',
                    desc: null,
                    image: require('../../../assets/images/lesson/lesson-focus.png'),
                },
                {
                    uid: '1.17',
                    active: false,
                    completed: false,
                    name: 'City',
                    key: 'cz_city',
                    desc: null,
                    image: require('../../../assets/images/lesson/lesson-focus.png'),
                },
                {
                    uid: '1.18',
                    active: false,
                    completed: false,
                    name: 'Secondary Number',
                    key: 'cz_secondary_num',
                    desc: null,
                    image: require('../../../assets/images/lesson/lesson-focus.png'),
                },
            ],
        }
    ];

    state = {
        working: false,
        formSectionActive: {
            parent: '1',
            child: '1.1',
        },
        countries: [],
        cz_invoice_types: [{ label: 'SIMPLIFIED', value: 'SIMPLIFIED' }, { label: 'STANDARD', value: 'STANDARD' }, { label: 'BOTH', value: 'BOTH' }],
        formSections: this.formSections,
        formFields: {
            'cz_email': '',
            'cz_common_name': '',
            'cz_org_unit_name': '',
            'cz_org_name': '',
            'cz_tax_num': '',
            'cz_reg_address': '',
            'cz_business_category': '',
            'cz_egs_serial_num': '',
            'cz_reg_num': '',
            'cz_invoice_type': '',
            'cz_country': '',
            'cz_otp': '',
            'cz_street': '',
            'cz_building': '',
            'cz_district': '',
            'cz_postal_code': '',
            'cz_city': '',
            'cz_secondary_num': '',
            'cz_zatca_settings': null,
            'last_invoice_hash': null,
        }
    }

    componentDidMount() {
        this.getCountries();
        this.getCenterZatca();
    }

    componentDidUpdate(prevProps, prevState) {
        // if (prevProps.authData.centerData.center_id !== this.props.authData.centerData.center_id) {
        //     this.getCenterZatca();
        // }
        if (prevProps.updateZatcaModal != this.props.updateZatcaModal && this.props.updateZatcaModal) {
            this.getCenterZatca();
        }
    }

    getCenterZatca = async () => {
        const res = await GET('center-zatca/get');
        if (res) {
            let resData = res.data
            if (resData) {
                let formFields = resData
                if (formFields.cz_country) {
                    formFields.cz_country = this.state.countries.find((v) => v.value == formFields.cz_country)
                }
                if (formFields.cz_invoice_type) {
                    formFields.cz_invoice_type = this.state.cz_invoice_types.find((v) => v.value == formFields.cz_invoice_type)
                }
                formFields.cz_zatca_settings = (formFields.cz_zatca_settings) ? JSON.parse(formFields.cz_zatca_settings) : null
                formFields.cz_last_invoice_hash = (formFields.cz_last_invoice_hash) ? JSON.parse(formFields.cz_last_invoice_hash) : null
                this.setState({ formFields }, () => this.checkCompletedFormSections());
            }
        }
    }

    getCountries = async () => {
        const res = await GET('admin/get-countries');
        if (res.status == 200) {
            const countries = res.data.map((v) => {
                v.label = v.name_en;
                v.value = v.iso2;
                return v;
            });
            this.setState({ countries });
        }
    }


    // MARK FORM SECTIONS AS COMPLETE AFTER VERIFYING THE REQUIRED FIELDS DATA
    checkCompletedFormSections = () => {
        let formSections = this.state.formSections;
        formSections = formSections.map((v, i) => {
            let data = v.data;
            let sectionComplete = true;
            data = data.map((vv, ii) => {

                let subSectionComplete = false;
                if (this.state.formFields[vv.key] != '') {
                    subSectionComplete = true;
                } else {
                    subSectionComplete = false;
                    sectionComplete = false;
                }
                return { ...vv, completed: subSectionComplete };

            });
            return { ...v, data, completed: sectionComplete };
        });
        this.setState({ formSections: formSections });
    };
    // CHANGE AND SCROLL TO SECTION
    changeToFromSection = (parent, child) => {
        this.setState(
            {
                formSectionActive: { parent: parent, child: child },
            },
            () => {
                setTimeout(() => {
                    const element = document.getElementById('form_section_' + parent);
                    if (element) {
                        // 👇 Will scroll smoothly to the top of the next section
                        element.scrollIntoView({ behavior: 'smooth' });
                    }
                }, 300);
            }
        );
    };

    saveZatcaSettings = async () => {
        this.setState({ working: true });
        let centerZatcaData = { ...this.state.formFields }
        centerZatcaData.cz_country = (centerZatcaData.cz_country) ? centerZatcaData.cz_country.value : ''
        centerZatcaData.cz_invoice_type = (centerZatcaData.cz_invoice_type) ? centerZatcaData.cz_invoice_type.value : ''

        const fData = new FormData();
        fData.append('centerZatcaData', JSON.stringify(centerZatcaData))
        try {
            const res = await POST('center-zatca/save', fData, {

            });
            let resData = res.data
            if (resData.type) {
                let formFields = resData.data
                if (formFields.cz_country) {
                    formFields.cz_country = this.state.countries.find((v) => v.value == formFields.cz_country)
                }
                if (formFields.cz_invoice_type) {
                    formFields.cz_invoice_type = this.state.cz_invoice_types.find((v) => v.value == formFields.cz_invoice_type)
                }
                formFields.cz_zatca_settings = (formFields.cz_zatca_settings) ? JSON.parse(formFields.cz_zatca_settings) : null
                formFields.cz_last_invoice_hash = (formFields.cz_last_invoice_hash) ? JSON.parse(formFields.cz_last_invoice_hash) : null
                this.setState({ formFields }, () => this.checkCompletedFormSections())
                toast.success(res.data.message);
            } else {
                if (resData.data) {
                    handleFormErrors(resData.data)
                } else {
                    toast[resData.messageType](resData.message);
                }
            }

            this.setState({ working: false });

        } catch (err) {
            console.log('err', err)

            this.setState({ working: false });
            toast.error('Something went wrong!');
        }
    }
    setFormFields = (key, value) => {
        let formFields = this.state.formFields
        formFields[key] = value
        this.setState({ formFields }, () => this.checkCompletedFormSections())
    }

    render() {
        let { formFields } = this.state
        console.log('this/state', this.state);

        return (<Offcanvas
            show={this.props.updateZatcaModal}
            onHide={() => this.props.setUpdateZatcaModal(false)}
            placement='bottom'
            style={{ height: '100%' }}>
            <Offcanvas.Header id='iedu-header' style={{ marginTop: '1rem', marginRight: '1rem', marginLeft: '1rem', marginBottom: 0 }}>
                <div className='d-flex flex-row'>
                    <span className='header-back-btn' onClick={() => this.props.setUpdateZatcaModal(false)} style={{ marginRight: 10 }}>
                        <FontAwesomeIcon icon={faArrowAltCircleLeft} color={brand_colors[this.props.defaultTheme.theme_id].color9} />
                    </span>
                    <Offcanvas.Title>{t('ZATCA Settings')}</Offcanvas.Title>
                </div>

                <div>
                    {([22].includes(this.props.authData.loginData.role_id)) &&
                        <Button variant='light' onClick={() => {
                            this.setState({ formFields: { ...formFields, ...localTestData } })
                        }}>
                            Fill Sample Data
                        </Button>
                    }
                    {([22].includes(this.props.authData.loginData.role_id)) &&
                        <Button variant='light' onClick={() => {
                            this.setState({ formFields: { ...formFields, ...localArtalData } })
                        }}>
                            Artal Sample Data
                        </Button>
                    }
                    <Button disabled={this.state.working} variant='warning' onClick={() => this.saveZatcaSettings()}>
                        {t('Update')} {this.state.working ? <Spinner as='span' animation='grow' size='sm' role='status' aria-hidden='true' /> : ''}
                    </Button>
                </div>

            </Offcanvas.Header>
            <Offcanvas.Body>
                <div
                    className={'d-flex flex-row grey-section'}
                    style={{
                        overflow: 'initial',
                        backgroundImage: 'url(https://academic.educore.io/static/media/pegboard-bg.9b84e4936acef29bbcd9.png)',
                        backgroundRepeat: 'repeat',
                        backgroundPosition: '10px 12px',
                        overflow: 'hidden',
                    }}
                >
                    <div style={{ backgroundColor: brand_colors[this.props.defaultTheme.theme_id].color8, marginRight: 10, borderRadius: '20px', width: '250px', height: '78vh', top: '5px', position: 'sticky', paddingLeft: 20, overflowY: 'auto' }}>
                        <div style={{ paddingRight: '1.5rem', paddingBottom: '1.5rem', paddingTop: '1rem' }}>
                            {this.state.formSections && this.state.formSections.map((v, i) => {
                                return (
                                    <div key={i}>
                                        <div className='d-flex flex-row align-items-center' style={{ cursor: 'pointer', borderRadius: '20px', paddingLeft: '5px', paddingRight: '5px', backgroundColor: v.uid == this.state.formSectionActive.parent ? brand_colors[this.props.defaultTheme.theme_id].color19 : brand_colors[this.props.defaultTheme.theme_id].color8, zIndex: 1, position: 'relative' }} onClick={() => this.changeToFromSection(v.uid, v.uid + '.1')}>
                                            <FontAwesomeIcon
                                                icon={v.completed ? faCheckCircle : faCircle}
                                                color={v.uid == this.state.formSectionActive.parent ? brand_colors[this.props.defaultTheme.theme_id].color20 : v.completed ? brand_colors[this.props.defaultTheme.theme_id].color4 : brand_colors[this.props.defaultTheme.theme_id].color9}
                                                style={{
                                                    fontSize: 12,
                                                    marginRight: 5,
                                                    opacity: v.uid == this.state.formSectionActive.parent || v.completed ? 1 : 0.7,
                                                }}
                                            />
                                            <span style={{ fontSize: 18, fontWeight: '600', color: v.uid == this.state.formSectionActive.parent ? brand_colors[this.props.defaultTheme.theme_id].color20 : brand_colors[this.props.defaultTheme.theme_id].color9, opacity: v.uid == this.state.formSectionActive.parent ? 1 : 0.7 }}>{v.name}</span>
                                        </div>

                                        <div style={{ paddingLeft: '1rem', borderLeft: 'solid 1px brand_colors[this.props.defaultTheme.theme_id].color18', marginLeft: '1.5rem' }}>
                                            {v.data.map((vv, ii) => {
                                                return (
                                                    <div key={ii} className='d-flex flex-row align-items-center' style={{ marginBottom: 5, marginTop: 2, cursor: 'pointer' }} onClick={() => this.changeToFromSection(v.uid, vv.uid)}>
                                                        <FontAwesomeIcon icon={vv.completed ? faCheckCircle : faCircle} color={vv.completed ? brand_colors[this.props.defaultTheme.theme_id].color4 : brand_colors[this.props.defaultTheme.theme_id].color18} style={{ fontSize: 12, marginRight: 5 }} />
                                                        <span style={{ fontSize: 14, color: vv.completed ? brand_colors[this.props.defaultTheme.theme_id].color4 : brand_colors[this.props.defaultTheme.theme_id].color18 }}>{vv.name}</span>
                                                    </div>
                                                );
                                            })}
                                        </div>
                                    </div>
                                );
                            })}
                        </div>
                    </div>
                    <Col className='custom-styled-form hide-scrollbar' style={{ backgroundColor: brand_colors[this.props.defaultTheme.theme_id].color8, marginLeft: 10, borderRadius: '20px', padding: '1rem', overflow: 'auto', height: '78vh' }}>
                        {this.state.formSectionActive.parent == '1' && (
                            <div id='form_section_1'>
                                <h5>{t('General')}</h5>
                                <Row>
                                    <Col md={3}>
                                        <Form.Group className="mb-3">
                                            <Form.Label>{t('OTP')}
                                                <span onClick={() => {
                                                    let findSectionKey = this.state.formSections[0].data.find((v) => v.key == 'cz_otp')

                                                    if (findSectionKey) {
                                                        toast.info(findSectionKey.desc)
                                                    }
                                                }}>
                                                    <FontAwesomeIcon icon={faInfoCircle} style={{ marginLeft: 5, marginRight: 5 }} />
                                                </span>
                                            </Form.Label>
                                            <Form.Control type="text"
                                                readOnly={(formFields.cz_zatca_settings) ? true : false}
                                                defaultValue={formFields.cz_otp}
                                                onBlur={(e) => this.setFormFields('cz_otp', e.target.value)} />
                                        </Form.Group>
                                    </Col>
                                    <Col md={3}>
                                        <Form.Group className="mb-3">
                                            <Form.Label>{t('EGS Serial Number')}
                                                <span onClick={() => {
                                                    let findSectionKey = this.state.formSections[0].data.find((v) => v.key == 'cz_egs_serial_num')

                                                    if (findSectionKey) {
                                                        toast.info(findSectionKey.desc)
                                                    }
                                                }}>
                                                    <FontAwesomeIcon icon={faInfoCircle} style={{ marginLeft: 5, marginRight: 5 }} />
                                                </span>
                                            </Form.Label>
                                            <Form.Control type="text"
                                                readOnly={(formFields.cz_zatca_settings) ? true : false}
                                                defaultValue={formFields.cz_egs_serial_num}
                                                onBlur={(e) => this.setFormFields('cz_egs_serial_num', e.target.value)} />
                                        </Form.Group>
                                    </Col>
                                </Row>
                                <Row>
                                    <Col md={3}>
                                        <Form.Group className="mb-3">
                                            <Form.Label>{t('Common Name')}
                                                <span onClick={() => {
                                                    let findSectionKey = this.state.formSections[0].data.find((v) => v.key == 'cz_common_name')

                                                    if (findSectionKey) {
                                                        toast.info(findSectionKey.desc)
                                                    }
                                                }}>
                                                    <FontAwesomeIcon icon={faInfoCircle} style={{ marginLeft: 5, marginRight: 5 }} />
                                                </span>
                                            </Form.Label>
                                            <Form.Control type="text"
                                                readOnly={(formFields.cz_zatca_settings) ? true : false}
                                                defaultValue={formFields.cz_common_name}
                                                onBlur={(e) => this.setFormFields('cz_common_name', e.target.value)} />
                                        </Form.Group>
                                    </Col>
                                    <Col md={3}>
                                        <Form.Group className="mb-3">
                                            <Form.Label>{t('Organizational Unit Name')}
                                                <span onClick={() => {
                                                    let findSectionKey = this.state.formSections[0].data.find((v) => v.key == 'cz_org_unit_name')

                                                    if (findSectionKey) {
                                                        toast.info(findSectionKey.desc)
                                                    }
                                                }}>
                                                    <FontAwesomeIcon icon={faInfoCircle} style={{ marginLeft: 5, marginRight: 5 }} />
                                                </span>
                                            </Form.Label>
                                            <Form.Control type="text"
                                                readOnly={(formFields.cz_zatca_settings) ? true : false}
                                                defaultValue={formFields.cz_org_unit_name}
                                                onBlur={(e) => this.setFormFields('cz_org_unit_name', e.target.value)} />
                                        </Form.Group>
                                    </Col>
                                    <Col md={3}>
                                        <Form.Group className="mb-3">
                                            <Form.Label>{t('Organization Name')}
                                                <span onClick={() => {
                                                    let findSectionKey = this.state.formSections[0].data.find((v) => v.key == 'cz_org_name')

                                                    if (findSectionKey) {
                                                        toast.info(findSectionKey.desc)
                                                    }
                                                }}>
                                                    <FontAwesomeIcon icon={faInfoCircle} style={{ marginLeft: 5, marginRight: 5 }} />
                                                </span>
                                            </Form.Label>
                                            <Form.Control type="text"
                                                readOnly={(formFields.cz_zatca_settings) ? true : false}
                                                defaultValue={formFields.cz_org_name}
                                                onBlur={(e) => this.setFormFields('cz_org_name', e.target.value)} />
                                        </Form.Group>
                                    </Col>
                                    <Col md={3}>
                                        <Form.Group className="mb-3">
                                            <Form.Label>{t('Tax Number')}
                                                <span onClick={() => {
                                                    let findSectionKey = this.state.formSections[0].data.find((v) => v.key == 'cz_tax_num')

                                                    if (findSectionKey) {
                                                        toast.info(findSectionKey.desc)
                                                    }
                                                }}>
                                                    <FontAwesomeIcon icon={faInfoCircle} style={{ marginLeft: 5, marginRight: 5 }} />
                                                </span>
                                            </Form.Label>
                                            <Form.Control type="text"
                                                readOnly={(formFields.cz_zatca_settings) ? true : false}
                                                defaultValue={formFields.cz_tax_num}
                                                onBlur={(e) => this.setFormFields('cz_tax_num', e.target.value)} />
                                        </Form.Group>
                                    </Col>
                                </Row>
                                <Row>
                                    <Col md={3}>
                                        <Form.Group className="mb-3">
                                            <Form.Label>{t('Email')}
                                                <span onClick={() => {
                                                    let findSectionKey = this.state.formSections[0].data.find((v) => v.key == 'cz_email')

                                                    if (findSectionKey) {
                                                        toast.info(findSectionKey.desc)
                                                    }
                                                }}>
                                                    <FontAwesomeIcon icon={faInfoCircle} style={{ marginLeft: 5, marginRight: 5 }} />
                                                </span>
                                            </Form.Label>
                                            <Form.Control type="text"
                                                readOnly={(formFields.cz_zatca_settings) ? true : false}
                                                defaultValue={formFields.cz_email}
                                                onBlur={(e) => this.setFormFields('cz_email', e.target.value)} />
                                        </Form.Group>
                                    </Col>
                                    <Col md={3}>
                                        <Form.Group className="mb-3">
                                            <Form.Label>{t('Business Category')}
                                                <span onClick={() => {
                                                    let findSectionKey = this.state.formSections[0].data.find((v) => v.key == 'cz_business_category')
                                                    if (findSectionKey) {
                                                        toast.info(findSectionKey.desc)
                                                    }
                                                }}>
                                                    <FontAwesomeIcon icon={faInfoCircle} style={{ marginLeft: 5, marginRight: 5 }} />
                                                </span>
                                            </Form.Label>
                                            <Form.Control type="text"
                                                readOnly={(formFields.cz_zatca_settings) ? true : false}
                                                defaultValue={formFields.cz_business_category}
                                                onBlur={(e) => this.setFormFields('cz_business_category', e.target.value)} />
                                        </Form.Group>
                                    </Col>
                                    <Col md={3}>
                                        <Form.Group className="mb-3">
                                            <Form.Label>{t('Invoice Type')}
                                                <span onClick={() => {
                                                    let findSectionKey = this.state.formSections[0].data.find((v) => v.key == 'cz_invoice_type')

                                                    if (findSectionKey) {
                                                        toast.info(findSectionKey.desc)
                                                    }
                                                }}>
                                                    <FontAwesomeIcon icon={faInfoCircle} style={{ marginLeft: 5, marginRight: 5 }} />
                                                </span>
                                            </Form.Label>
                                            <Select
                                                classNamePrefix='custom-styled-select'
                                                options={this.state.cz_invoice_types}
                                                value={this.state.formFields.cz_invoice_type}
                                                menuPortalTarget={document.body}
                                                styles={{
                                                    menuPortal: (base) => ({ ...base, zIndex: 9999, }),
                                                }}
                                                onChange={(obj) => this.setFormFields('cz_invoice_type', obj)}
                                            />
                                        </Form.Group>
                                    </Col>
                                    <Col md={3}>
                                        <Form.Group className="mb-3">
                                            <Form.Label>{t('Registration Number')}
                                                <span onClick={() => {
                                                    let findSectionKey = this.state.formSections[0].data.find((v) => v.key == 'cz_reg_num')

                                                    if (findSectionKey) {
                                                        toast.info(findSectionKey.desc)
                                                    }
                                                }}>
                                                    <FontAwesomeIcon icon={faInfoCircle} style={{ marginLeft: 5, marginRight: 5 }} />
                                                </span>
                                            </Form.Label>
                                            <Form.Control type="text"
                                                readOnly={(formFields.cz_zatca_settings) ? true : false}
                                                defaultValue={formFields.cz_reg_num}
                                                onBlur={(e) => this.setFormFields('cz_reg_num', e.target.value)} />
                                        </Form.Group>
                                    </Col>
                                </Row>
                                <Row>
                                    <Col md={3}>
                                        <Form.Group className="mb-3">
                                            <Form.Label>{t('Street')}
                                                <span onClick={() => {
                                                    let findSectionKey = this.state.formSections[0].data.find((v) => v.key == 'cz_street')

                                                    if (findSectionKey) {
                                                        toast.info(findSectionKey.desc)
                                                    }
                                                }}>
                                                    <FontAwesomeIcon icon={faInfoCircle} style={{ marginLeft: 5, marginRight: 5 }} />
                                                </span>
                                            </Form.Label>
                                            <Form.Control type="text"
                                                readOnly={(formFields.cz_zatca_settings) ? true : false}
                                                defaultValue={formFields.cz_street}
                                                onBlur={(e) => this.setFormFields('cz_street', e.target.value)} />
                                        </Form.Group>
                                    </Col>
                                    <Col md={3}>
                                        <Form.Group className="mb-3">
                                            <Form.Label>{t('Building')}
                                                <span onClick={() => {
                                                    let findSectionKey = this.state.formSections[0].data.find((v) => v.key == 'cz_building')

                                                    if (findSectionKey) {
                                                        toast.info(findSectionKey.desc)
                                                    }
                                                }}>
                                                    <FontAwesomeIcon icon={faInfoCircle} style={{ marginLeft: 5, marginRight: 5 }} />
                                                </span>
                                            </Form.Label>
                                            <Form.Control type="text"
                                                readOnly={(formFields.cz_zatca_settings) ? true : false}
                                                defaultValue={formFields.cz_building}
                                                onBlur={(e) => this.setFormFields('cz_building', e.target.value)} />
                                        </Form.Group>
                                    </Col>
                                    <Col md={3}>
                                        <Form.Group className="mb-3">
                                            <Form.Label>{t('District')}
                                                <span onClick={() => {
                                                    let findSectionKey = this.state.formSections[0].data.find((v) => v.key == 'cz_district')

                                                    if (findSectionKey) {
                                                        toast.info(findSectionKey.desc)
                                                    }
                                                }}>
                                                    <FontAwesomeIcon icon={faInfoCircle} style={{ marginLeft: 5, marginRight: 5 }} />
                                                </span>
                                            </Form.Label>
                                            <Form.Control type="text"
                                                readOnly={(formFields.cz_zatca_settings) ? true : false}
                                                defaultValue={formFields.cz_district}
                                                onBlur={(e) => this.setFormFields('cz_district', e.target.value)} />
                                        </Form.Group>
                                    </Col>
                                    <Col md={3}>
                                        <Form.Group className="mb-3">
                                            <Form.Label>{t('City')}
                                                <span onClick={() => {
                                                    let findSectionKey = this.state.formSections[0].data.find((v) => v.key == 'cz_city')

                                                    if (findSectionKey) {
                                                        toast.info(findSectionKey.desc)
                                                    }
                                                }}>
                                                    <FontAwesomeIcon icon={faInfoCircle} style={{ marginLeft: 5, marginRight: 5 }} />
                                                </span>
                                            </Form.Label>
                                            <Form.Control type="text"
                                                readOnly={(formFields.cz_zatca_settings) ? true : false}
                                                defaultValue={formFields.cz_city}
                                                onBlur={(e) => this.setFormFields('cz_city', e.target.value)} />
                                        </Form.Group>
                                    </Col>
                                </Row>
                                <Row>
                                    <Col md={3}>
                                        <Form.Group className="mb-3">
                                            <Form.Label>{t('Postal Code')}
                                                <span onClick={() => {
                                                    let findSectionKey = this.state.formSections[0].data.find((v) => v.key == 'cz_postal_code')

                                                    if (findSectionKey) {
                                                        toast.info(findSectionKey.desc)
                                                    }
                                                }}>
                                                    <FontAwesomeIcon icon={faInfoCircle} style={{ marginLeft: 5, marginRight: 5 }} />
                                                </span>
                                            </Form.Label>
                                            <Form.Control type="text"
                                                readOnly={(formFields.cz_zatca_settings) ? true : false}
                                                defaultValue={formFields.cz_postal_code}
                                                onBlur={(e) => this.setFormFields('cz_postal_code', e.target.value)} />
                                        </Form.Group>
                                    </Col>
                                    <Col md={3}>
                                        <Form.Group className="mb-3">
                                            <Form.Label>{t('Secondary Number')}
                                                <span onClick={() => {
                                                    let findSectionKey = this.state.formSections[0].data.find((v) => v.key == 'cz_secondary_num')

                                                    if (findSectionKey) {
                                                        toast.info(findSectionKey.desc)
                                                    }
                                                }}>
                                                    <FontAwesomeIcon icon={faInfoCircle} style={{ marginLeft: 5, marginRight: 5 }} />
                                                </span>
                                            </Form.Label>
                                            <Form.Control type="text"
                                                readOnly={(formFields.cz_zatca_settings) ? true : false}
                                                defaultValue={formFields.cz_secondary_num}
                                                onBlur={(e) => this.setFormFields('cz_secondary_num', e.target.value)} />
                                        </Form.Group>
                                    </Col>
                                    <Col md={3}>
                                        <Form.Group className="mb-3">
                                            <Form.Label>{t('Address')}
                                                <span onClick={() => {
                                                    let findSectionKey = this.state.formSections[0].data.find((v) => v.key == 'cz_reg_address')

                                                    if (findSectionKey) {
                                                        toast.info(findSectionKey.desc)
                                                    }
                                                }}>
                                                    <FontAwesomeIcon icon={faInfoCircle} style={{ marginLeft: 5, marginRight: 5 }} />
                                                </span>
                                            </Form.Label>
                                            <Form.Control type="text"
                                                readOnly={(formFields.cz_zatca_settings) ? true : false}
                                                defaultValue={formFields.cz_reg_address}
                                                onBlur={(e) => this.setFormFields('cz_reg_address', e.target.value)} />
                                        </Form.Group>
                                    </Col>
                                    <Col md={3}>
                                        <Form.Group className="mb-3">
                                            <Form.Label>{t('Country')}
                                                <span onClick={() => {
                                                    let findSectionKey = this.state.formSections[0].data.find((v) => v.key == 'cz_country')

                                                    if (findSectionKey) {
                                                        toast.info(findSectionKey.desc)
                                                    }
                                                }}>
                                                    <FontAwesomeIcon icon={faInfoCircle} style={{ marginLeft: 5, marginRight: 5 }} />
                                                </span>
                                            </Form.Label>
                                            <Select
                                                classNamePrefix='custom-styled-select'
                                                options={this.state.countries}
                                                value={formFields.cz_country}
                                                menuPortalTarget={document.body}
                                                styles={{
                                                    menuPortal: (base) => ({ ...base, zIndex: 9999, }),
                                                }}
                                                onChange={(obj) => this.setFormFields('cz_country', obj)}
                                            />
                                        </Form.Group>
                                    </Col>
                                </Row>
                            </div>)}
                    </Col>
                </div>
            </Offcanvas.Body >
        </Offcanvas >);
    }
}

const mapStateToProps = (state) => ({
    authData: state.auth.authData,
    defaultTheme: state.theme.defaultTheme,
    updateZatcaModal: state.updateZatcaModal.showModal
});

const mapDispatchToProps = () => ({
    setUpdateZatcaModal,
    setAuthentication
});

export default connect(mapStateToProps, mapDispatchToProps())(UpdateZatcaModal);


